import { useTranslation } from 'react-i18next';
import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { usePurchaseRoModel } from "../purchaseRoModel";
import { YhTag } from "@/erp_subpackage/components/YhTag";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { momentFormat, formatNum } from "@/erp_subpackage/utils/util";
import YhTooltip from "@/erp_subpackage/components/YhTooltip"
import { getCurrentCurrencySymbol } from '@/utils/currencyUtils';

export function DataTable({ goPageNav }) {
    const { t } = useTranslation();
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
    } = usePurchaseRoModel();

    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])
    const columns = [
        {
            title: t(`purchase.view.DataTable.序号`),
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: t(`purchase.view.DataTable.退货单号`),
            width: 120,
            fixed: "left",
            dataIndex: 'returnCode',
            render: (text) => <YhTooltip text={text} onClick={() => goPageNav("look", text)} />,
            // render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line click-span" onClick={() => goPageNav("look", text)}>{text}</p></Tooltip>,
        }, {
            title: t(`purchase.view.DataTable.单据状态`),
            width: 80,
            fixed: "left",
            dataIndex: 'status',
            render: (text) => <YhTag status={text} text={getTreeNodeName(text)} />,
        }, {
            title: t(`purchase.view.DataTable.所属机构`),
            width: 120,
            dataIndex: 'shopName',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`purchase.view.DataTable.支付状态`),
            width: 70,
            dataIndex: 'payStatus',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
        }, {
            title: t(`purchase.view.DataTable.退货数量`),
            width: 80,
            dataIndex: 'totalNum',
        }, {
            title: t(`purchase.view.DataTable.已收金额`),
            width: 80,
            dataIndex: 'paidAmount',
            render: (text) => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        }, {
            title: t(`purchase.view.DataTable.结算类型`),
            width: 80,
            dataIndex: 'payType',
            render: (text) => <YhTooltip text={getTreeNodeName(text)} />,
            //render: (text) => getTreeNodeName(text)

        }, {
            title: t(`purchase.view.DataTable.结算方式`),
            width: 80,
            dataIndex: 'payMethodName',
            render: (text, record) => <YhTooltip text={record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName} />,
            //render: (text, record) => <Tooltip placement="topLeft" title={record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}><p className="one-line">{record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}</p></Tooltip>,
        }, {
            title: t(`purchase.view.DataTable.发票类型`),
            width: 120,
            dataIndex: 'invoiceTypeName',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`purchase.view.DataTable.联系人`),
            width: 120,
            dataIndex: 'contact',
            render: (text) => <YhTooltip text={text} />,
            // render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
        }, {
            title: t(`purchase.view.DataTable.联系电话`),
            width: 95,
            dataIndex: 'phone',
        }, {
            title: t(`purchase.view.DataTable.制单人`),
            width: 120,
            dataIndex: 'createUser',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`purchase.view.DataTable.制单时间`),
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: t(`purchase.view.DataTable.库管员`),
            width: 120,
            dataIndex: 'storekeeper',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`purchase.view.DataTable.出库时间`),
            width: 130,
            dataIndex: 'stockIoTime',
            render: (text) => momentFormat(text)
        }, {
            title: t(`purchase.view.DataTable.结算员`),
            width: 120,
            dataIndex: 'reckoner',
            render: (text) => <YhTooltip text={text} />,
        }, {
            title: t(`purchase.view.DataTable.结算时间`),
            width: 130,
            dataIndex: 'settleTime',
            render: (text) => momentFormat(text)
        }, {
            title: t(`purchase.view.DataTable.核销时间`),
            width: 130,
            dataIndex: 'writeOffTime',
            render: (text) => momentFormat(text)
        }, {
            title: t(`purchase.view.DataTable.作废原因`),
            width: 120,
            dataIndex: 'cancelReason',
        }, {
            title: t(`purchase.view.DataTable.备注`),
            width: 120,
            dataIndex: 'note',
        },
        // {
        //     title: '商品类型',
        //     width: 120,
        //     dataIndex: 'note',
        // }, 
        {
            title: t(`purchase.view.DataTable.供应商`),
            width: 160,
            dataIndex: 'supplierName',
            render: (text) => <YhTooltip text={text} />,
            // render: (text) => <Tooltip placement="topLeft" title={text}><p className="one-line">{text}</p></Tooltip>,
            fixed: "right"

        }, {
            title: t(`purchase.view.DataTable.采退金额`),
            width: 80,
            dataIndex: 'payableAmount',
            fixed: "right",
            render: (text) => `${getCurrentCurrencySymbol()}${formatNum(text)}`
        }, {
            title: t(`purchase.view.DataTable.打印次数`),
            width: 70,
            fixed: "right",
            align: "center",
            dataIndex: 'printingTimes',
        }
    ];

    //点击行
    const onRow = (record) => {
        let findObj = selectedRowKeys.find(item => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter(item => item.id !== record.id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            setSelectedRowKeys(origin => [...origin, record]);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map(item => item.id);
                            return origin.filter(item => changeRowId.indexOf(item.id) < 0)
                        });
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map(item => item.id)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `${t(`purchase.view.DataTable.共`)}${pgCfg.total}${t(`purchase.view.DataTable.条`)}`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record]);
                }
            })}
            scroll={dataSource.length ? { x: 'max-content', y: "calc(100vh - 430px)" } : { x: 'max-content' }}
        />
    )
}

